"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("../constants");
var handleOnKeyboardConfirm = function handleOnKeyboardConfirm(action) {
  return function (event) {
    if (event.key === _constants.KEY_VALUES.ENTER || event.key === _constants.KEY_VALUES.SPACE) {
      action(event);
    }
  };
};
var _default = exports["default"] = handleOnKeyboardConfirm;